export const isWidgetUnique = (widgets, widget) =>
  !widgets.some(
    (theWidget) => theWidget.name === widget.name && theWidget.version === widget.version && theWidget.id !== widget.id
  );
